import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { zefDialogClose, onZefDialogOpen } from '@zerops/zef/dialog';
import { UserData } from '@zerops/models/user-data';
import { successOf } from '@zerops/zef/entities';
import { UserDataEntity, setActiveId } from '@zerops/zerops/core/user-data-base';
import { UserDataEditForm } from '@zerops/zui/user-data-edit-form';
import { map, filter, switchMap, delay } from 'rxjs/operators';
import { FEATURE_NAME } from './user-data-edit-dialog.constant';

@Injectable()
export class UserDataEditDialogEffect {

  onUserDataUpdateDialogOpen$ = createEffect(() => this._actions$.pipe(
    onZefDialogOpen(this._userDataEntity.updateOne.type),
    map(({ meta: { key, content, type, sensitive } }) => this._userDataEditForm.setValue({ key, content, type, sensitive: !!sensitive }))
  ));

  onDialogOpenFocusInput$ = createEffect(() => this._actions$.pipe(
    onZefDialogOpen(FEATURE_NAME),
    delay(100),
    map(() => this._userDataEditForm.focus('key'))
  ));

  private _onUserDataUpdateSuccess$ = this._actions$.pipe(
    successOf<UserData>(this._userDataEntity.updateOne)
  );

  onUpdateSuccessDialogClose$ = createEffect(() => this._onUserDataUpdateSuccess$.pipe(
    map(() => zefDialogClose({ key: FEATURE_NAME }))
  ));

  onDialogCloseResetForm$ = createEffect(() => this._actions$.pipe(
    ofType(zefDialogClose),
    filter((action) => action?.key === FEATURE_NAME),
    delay(500),
    switchMap(() => [
      setActiveId(undefined),
      this._userDataEditForm.reset(),
      this._userDataEditForm.setDefaultValues()
    ])
  ));

  onDialogCloseReseActiveId$ = createEffect(() => this._actions$.pipe(
    ofType(zefDialogClose),
    filter((action) => action?.key === FEATURE_NAME),
    map(() => setActiveId(undefined))
  ));

  onUpdateSuccessResetActiveId$ = createEffect(() => this._onUserDataUpdateSuccess$.pipe(
    map(() => setActiveId(undefined))
  ));

  constructor(
    private _actions$: Actions,
    private _userDataEntity: UserDataEntity,
    private _userDataEditForm: UserDataEditForm,
  ) { }
}
